<div class="menu-container">
  <addin-menu></addin-menu>
</div>
<div class="page-content">
  <router-outlet></router-outlet>

  @if (isReservationLocationChangeReturning$ | async) {
    <div
      class="page-loading"
      role="status"
      aria-live="polite"
      [attr.aria-label]="translation.newReservationUi.state.loading | transloco"
    >
      <cue-loading></cue-loading>
    </div>
  }
</div>
